import React from 'react';
import { getImage } from 'gatsby-plugin-image';
import Link from '../../../plugins/gatsby-plugin-ap-i18next/src/link';
import Moment from 'react-moment';
import { useI18next } from '../../../plugins/gatsby-plugin-ap-i18next/src/useI18next';

import {
    card,
    imgBox,
    ratio,
    contentBox,
    header,
    smallHeader,
    subheader,
    date,
    more,
} from './post-card.module.scss';
import { IPostCard } from '../../models/post.model';
import { useTranslation } from '../../hooks/use-translation';
import { getMediaWithRelation } from '../../utils/get-relation';
import { config } from '../../config';
import ArrowRight from '../../assets/images/svg/arrow-right.svg';

import RatioImage from '../atoms/ratio-image';

const { relations, translationKeys } = config;

interface IPostCardProps {
    className?: string;
    post: IPostCard;
    titleTag?: React.ElementType;
    isSmall?: boolean;
}

const PostCard: React.FC<IPostCardProps> = ({
    className = '',
    post,
    titleTag = 'h2',
    isSmall = false,
}) => {
    const { t, language } = useI18next();
    const { slug, publishedAt } = post;
    const { title, lead, media } = useTranslation(post, translationKeys.postCard);
    const { remoteImage, alt } = getMediaWithRelation(media, relations.coverImage) || {};
    const TitleTag = titleTag;

    return (
        <Link
            to={`${slug}`}
            className={`
                ${card}
                ${className}
            `}
        >
            <RatioImage
                image={remoteImage && getImage(remoteImage)}
                alt={alt || title}
                className={imgBox}
                ratioClass={ratio}
            />
            <div className={contentBox}>
                <TitleTag className={isSmall ? smallHeader : header}>{title}</TitleTag>
                <Moment className={date} locale={language} unix={true} format="DD.MM.YYYY">
                    {publishedAt}
                </Moment>
                {lead && <p className={subheader}>{lead}</p>}
                <span className={more}>
                    {t('button.read')} <ArrowRight />
                </span>
            </div>
        </Link>
    );
};

export default PostCard;
